/**
 * Created by jv on 25/07/2017.
 */
const utils = require("Sources/utils/utils");

var hasLogged = false;

module.exports = (debug) =>
{
  let Logger = {};

  // function init(force)
  // {
  //   if(debug || __DEVELOPMENT__ || force)
  //   {
  //     for(var m in console)
  //     {
  //       if(utils.isFunction(console[m]))
  //       {
  //         Logger[m] = console[m].bind(window.console);
  //       }
  //     }
  //
  //     Logger.cssLog = function(...args)
  //     {
  //       if(!hasLogged)
  //       {
  //         Logger.info("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
  //         hasLogged = true;
  //       }
  //
  //       args = Logger.cssify.apply(null, args);
  //       return Logger.log.apply(null, args);
  //     }
  //   }
  //   else
  //   {
  //     for(var m in console)
  //     {
  //       if(utils.isFunction(console[m]))
  //       {
  //         Logger[m] = () => {};
  //       }
  //     }
  //
  //     Logger.cssLog = () => {};
  //   }
  // }
  //
  // init();

  function isDebug()
  {
    if(!window.console || !window.console.info || !window.console.debug || !window.console.error || !window.console.log || !window.console.warn || !window.console.trace)
    {
      return false;
    }

    return debug || __DEVELOPMENT__ || window.__PRODUCTION_LOGGING__;
  }

  function firstLogCheck()
  {
    if(!hasLogged)
    {
      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
      hasLogged = true;
    }
  }

  Logger.trace = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.trace.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.debug = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.debug.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.log = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.log.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.info = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.info.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.cssLog = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();
      args = Logger.cssify.apply(null, args);

      try
      {
        console.log.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.warn = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.warn.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.error = function(...args)
  {
    if(isDebug())
    {
      firstLogCheck();

      try
      {
        console.error.apply(null, args);
      }
      catch(e)
      {
        console.error(e);
      }
    }
  };

  Logger.cssify = function(...args)
  {
    if(args.length > 1)
    {
      let css = args[args.length - 1];
      args.splice(args.length - 1, 1);

      let cssString = "";

      for(let key in css)
      {
        if(css.hasOwnProperty(key))
        {
          cssString += (key + ": " + css[key] + ";");
        }
      }

      if(utils.isString(args[0]))
      {
        if((args[0].match(/%c/g) || []).length === 0)
        {
          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
          args[0] = "%c" + args[0] + "%c";

          args.splice(1, 0, cssString);
          //Resets the css
          args.push("");
        }
        else if(args.length === 1)
        {
          //If there's only text with no arguments, same as before, insert css at second and last place
          args.push(cssString);
          //Resets the css
          args.push("");
        }
        else
        {
          // Determine where the css arguments need to go in the array
          /*
             %s - String.
             %d - Number (integer or floating point value).
             %i - Integer.
             %f - Floating point value.
             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
             %o - JavaScript Object
           */

          // position BEFORE the first %c
          let startPos = args[0].indexOf("%c");
          // position AFTER the last %c
          let endPos = args[0].lastIndexOf("%c") + 2;

          if(startPos !== -1 && endPos !== -1 && startPos !== endPos)
          {
            let leftSubString = args[0].substring(0, startPos);
            let rightSubString = args[0].substr(endPos);
            // Find all format occurrences
            let firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
            let secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;

            // Account for the text that's in the first position
            args.splice(firstInsert + 1, 0, cssString);
            //Resets the css
            args.splice(args.length - secondInsert, 0, "");
          }
        }
      }

      return args;
    }
  };

  // http://www.flatuicolorpicker.com/
  /*
    SUMMER SKY
    1E8BC3
    30, 139, 195
   */
  Logger.infoCss = {
    "background-color": "#1E8BC3",
    "color": "#ffffff"
  };

  /*
    EUCALYPTUS
    26A65B
    38, 166, 91
   */
  Logger.successCss = {
    "background-color": "#26A65B",
    "color": "#ffffff"
  };

  /*
    SANDSTORM
    F9BF3B
    249, 191, 59
   */
  Logger.warningCss = {
    "background-color": "#F9BF3B",
    "color": "#000000"
  };

  /*
    FLAMINGO
    EF4836
    239, 72, 54
   */
  Logger.errorCss = {
    "background-color": "#EF4836",
    "color": "#ffffff"
  };

  return Logger;
};

/*
Examples:

logger.info("Hi");
logger.warn("Warning");
logger.error("Error");
logger.cssLog("Hi %s", "Jan", logger.successCss);
logger.cssLog("Hi %cthere Jan%c", logger.warningCss);
logger.cssLog("Hi there %s, my name is %c%s and I am%c %d", "Jan", "Someone", 23, logger.errorCss);
*/



// WEBPACK FOOTER //
// ./app/js/utils/logger.js